import { Box, Dialog, Modal, } from "@mui/material";
import styled from "styled-components";
import CustomDataGrid from "../../shared/Shared Utils/CustomDataTable";
import { STOCK_STATUS_BY_HUB_API } from "../../shared/Shared Utils/AppData";

const HUB_ITEMS_COLUMN = [
    { field: "RowNumber", headerName: " ", width: 50 },
    {
      field: "Environment",
      renderHeader: (params) => <strong>{"Site"}</strong>,
      flex: 2,
    },
    {
      field: "SOH",
      renderHeader: (params) => <strong>{"SOH"}</strong>,
      flex: 1,
      type: "decimalZero",
    },
    {
      field: "Ordered",
      renderHeader: (params) => <strong>{"Ordered"}</strong>,
      flex: 1,
      type: "decimalZero",
    },
    {
      field: "GIT",
      renderHeader: (params) => <strong>{"GIT"}</strong>,
      flex: 1,
      type: "decimalZero",
    },
    {
      field: "MOS",
      renderHeader: (params) => <strong>{"MOS"}</strong>,
      flex: 1,
      type: "decimal",
    },
    {
      field: "AMC",
      renderHeader: (params) => <strong>{"AMC"}</strong>,
      flex: 1,
      type: "decimalZero",
    },
    {
      field: "Min",
      renderHeader: (params) => <strong>{"MIN"}</strong>,
      flex: 1,
      type: "decimalZero",
    },
    
    {
      field: "Max",
      renderHeader: (params) => <strong>{"MAX"}</strong>,
      flex: 1,
      type: "decimalZero",
    },
    {
      field: "QuantityToReachMax",
      renderHeader: (params) => <strong>{"QTMax"}</strong>,
      flex: 1,
      type: "decimalZero",
    },
  ];

export const StockItemsModal = ({open, handleClose, productSN, modeCode}) => {

  return (
    
    <Modal
            open={open}
            onClose={() => handleClose(false)}
        >
        <Box 
          className="modal-class"  
          style={{
            padding: "1rem",
            paddingTop: "3rem",
            position: "relative",
            width: "80%",
            height: "38rem",
            background: "white",
            }}
          >
            <CustomDataGrid
              component_config={{
                title: "Item By HUBs",
                data_source_api: STOCK_STATUS_BY_HUB_API,
                data_property: "Data",
                columns: HUB_ITEMS_COLUMN,
                isSOH: false,
                width: "72vw",
                pageSize: 5,
                use_default_filter_params: false,
                defaultFilterParams: {ModeCode: modeCode, ProductSN: productSN, EnvironmentGroupCode: 'HUB', OrderBy: 'Environment' },
              }}
            />
          </Box>
        </Modal>
  )
}
  
const DialogWrapper = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 11px;
  }
  .header {
    background-color: #12b3b7;
    color: white;
  }
`;